import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import { getLang, STORE_KEY_ACCOUNT, storeGet } from 'mailup-react-helpers'
import { TOAST_VARIANT_SUCCESS, toastShow } from 'mailup-web-components'

import importAppSvg from 'mailup-web-components/resources/mailup-web-app/img/svg/import-app.svg'
import {
  deleteDynamicContentAction,
  getDynamicContentLastSentAction,
  getDynamicContentListAction,
  getFilterAction,
  getIntegrationsAction
} from '../actions/actions'
import {
  integrationsState,
  modalDeleteState,
  pageState,
  resultsState,
  searchState
} from '../state/page'
export const getDynamicContentListCallback =
  ({ set, snapshot, reset }) =>
  async ({
    pageNumber,
    pageSize,
    orderBy,
    orderDescending,
    isReset,
    isFirstLoading
  }) => {
    if (isFirstLoading) {
      set(pageState, (prev) => ({
        ...prev,
        loading: true,
        loaded: false
      }))
    }

    set(resultsState, (prev) => ({
      ...prev,
      loadingTable: true
    }))

    const search = await snapshot.getPromise(searchState)

    const searchParams = {
      ...search,
      pageNumber: pageNumber || search.pageNumber,
      pageSize: pageSize || search.pageSize,
      orderDescending:
        orderBy === search.orderBy
          ? !search.orderDescending
          : search.orderDescending,
      orderBy: orderBy || search.orderBy
    }

    try {
      const results = await getDynamicContentListAction(searchParams)
      set(resultsState, (prev) => ({
        ...prev,
        loadingTable: false,
        ...results
      }))

      set(searchState, searchParams)
      if (results && results.items.length) {
        results.items.forEach(async (i) => {
          let filterName = '-'
          if (i.IdFilter > 0) {
            const { Name } = await getFilterAction(i.IdFilter)
            filterName = i.IdFilter + ' - ' + Name
          }
          const lastSendDate = await getDynamicContentLastSentAction(i.Id)
          let str = ''
          switch (i.Type) {
            case 1:
              str = getIntl().formatMessage({
                id: 'Load.DynamicContentList.ContDinType_1'
              })
              break
            case 2:
              str = getIntl().formatMessage({
                id: 'Load.DynamicContentList.ContDinType_2'
              })
              break
            case 3:
              str = getIntl().formatMessage({
                id: 'Load.DynamicContentList.ContDinType_3'
              })
              break
            default:
              str = '-'
              break
          }
          set(resultsState, (prev) => ({
            ...prev,
            items: prev.items.map((m) =>
              m.Id === i.Id
                ? {
                    ...m,
                    FilterName: filterName,
                    TypeName: str,
                    LastSendDate: lastSendDate
                  }
                : m
            )
          }))
        })
      }
      if (isFirstLoading) {
        set(pageState, (prev) => ({
          ...prev,
          pageLoading: false,
          isEmptyState: !results || results.totalItems === 0
        }))
      }
    } catch (error) {
      logAppError({
        Component: 'DynamicContentList',
        Method: 'initPageCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
    set(pageState, (prev) => ({
      ...prev,
      loading: false,
      loaded: true
    }))
  }

export const initIntegrationsCallback =
  ({ set, snapshot }) =>
  async () => {
    set(integrationsState, (prev) => ({
      ...prev,
      loading: true,
      error: false
    }))
    try {
      const lang = getLang()
      const { Domain } = storeGet(STORE_KEY_ACCOUNT)
      const resp = await getIntegrationsAction(lang, 'dynamiccontent')

      const items = resp.map((o) => ({
        title: o.title,
        logo: `https://${Domain}/appImages/${o.logo}`,
        text: o.excerpt,
        url: o.url
      }))
      let otherUrl = 'https://integrations.mailup.com/en/'
      switch (lang.toLowerCase()) {
        case 'it':
          otherUrl = 'https://integrations.mailup.com/it/'
          break
        case 'es':
          otherUrl = 'https://integrations.mailup.com/es/'
          break
      }

      items.push({
        title: getIntl().formatMessage({
          id: 'Load.ListBuildingTools.lblListBuildingOther'
        }),
        logo: importAppSvg,
        text: getIntl().formatMessage({
          id: 'Load.ListBuildingTools.lblListBuildingOtherSubtitle'
        }),
        url: otherUrl
      })
      set(integrationsState, (prev) => ({
        ...prev,
        loaded: true,
        loading: false,
        error: false,
        items
      }))
    } catch (error) {
      logAppError({
        Component: 'DynamicContentList',
        Method: 'initIntegrationsCallback',
        appError: error
      })
      set(integrationsState, (prev) => ({
        ...prev,
        loaded: true,
        loading: false,
        error: true
      }))
    }
  }
export const deleteDynamicContentCallback =
  ({ set, snapshot, reset }) =>
  async ({ idContent }) => {
    try {
      await deleteDynamicContentAction(idContent)
      reset(modalDeleteState)
      toastShow(
        getIntl().formatMessage({
          id: 'Load.DynamicContentList.messageDeleteSucces'
        }),
        TOAST_VARIANT_SUCCESS,
        'AlertMessageDeleteSuccess'
      )
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, {
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      })
    }
  }
